export const asset = (url: string): string => {
  const base = import.meta.env.BASE_URL || '/'
  return `${base.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`
}
